import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../store";

import { UserWorkspaceStatus } from "@pl-flight-recorder/web/interfaces/UserWorkspaceStatus";
// import { User } from "@pl-flight-recorder/web/interfaces/user";
// import { setActiveWorkspace, setUserActiveWorkspace } from "./userSlice";

// interface User {
//   id: string | number;
// }

interface UserWorkspaceMap {
  status: string;
  role: {
    name: string;
  };
  user: {
    id: number;
    name: string;
    email: string;
  };
}

export interface Workspace {
  id: number;
  name: string;
  userworkspacemap: UserWorkspaceMap[];
  role: {
    name: string;
  };
  userWorkspaceStatus: UserWorkspaceStatus;
  adminUser?: {
    id: number;
    name: string;
  };
  avatar?: string;
}

interface WorkspaceState {
  workspaces: Workspace[];
  // activeWorkspaceId: number | null;
  activeWorkspace: {
    id: number;
    name: string;
    token: string;
    userworkspacemap: UserWorkspaceMap[];
  } | null;
  loading: boolean;
  error: string | null;
}

const initialState: WorkspaceState = {
  workspaces: [],
  // activeWorkspaceId: null,
  activeWorkspace: null,
  loading: false,
  error: null,
};

const workspaceSlice = createSlice({
  name: "workspace",
  initialState,
  reducers: {
    setWorkspaces: (state, action: PayloadAction<Workspace[]>) => {
      console.log("!!! setWorkspaces", action.payload);
      state.workspaces = action.payload;
    },
    setActiveWorkspaceFromId: (state, action: PayloadAction<number>) => {
      console.log("setActiveWorkspaceFromId change?", action.payload);
      // state.activeWorkspace = action.payload;
      state.activeWorkspace = {
        id: action.payload,
        name: "unkown",
        token: "do not use",
        userworkspacemap: [],
      };
      //call user slice action to setActiveWorkspace
      // dispatch(setUserActiveWorkspace({ id: action.payload, name: "unkown" }));
    },
    setActiveWorkspaceFromWorkspace: (
      state,
      action: PayloadAction<Workspace>,
    ) => {
      console.log(
        "setActiveWorkspaceFromWorkspace not implmented",
        action.payload,
      );
      state.activeWorkspace = {
        id: action.payload.id,
        name: action.payload.name,
        token: "do not use",
        userworkspacemap: action.payload.userworkspacemap || [],
      };
    },
    updateWorkspace: (state, action: PayloadAction<Workspace>) => {
      console.log(
        "slice updateWorkspace not implmented",
        action.payload,
        state,
      );
      state.activeWorkspace = {
        id: action.payload.id,
        name: action.payload.name,
        token: "do not use",
        userworkspacemap: action.payload.userworkspacemap || [],
      };
    },
    setActiveWorkspaceFromToken: (
      state,
      action: PayloadAction<{ workspaceId: number; token: string }>,
    ) => {
      console.log("setActiveWorkspaceFromToken", action.payload);
      console.log("state.workspaces", state.workspaces);
      state.activeWorkspace = {
        id: action.payload.workspaceId,
        name:
          state.workspaces.find((w) => w.id === action.payload.workspaceId)
            ?.name || "",
        userworkspacemap:
          state.workspaces.find((w) => w.id === action.payload.workspaceId)
            ?.userworkspacemap || [],
        token: action.payload.token,
      };
      // state.activeWorkspace = { id: action.payload.workspaceId, name: 'unkown', token: action.payload.token };
    },
  },
});

// Selectors
export const selectWorkspaces = (state: RootState) =>
  state.workspace.workspaces;
// export const selectActiveWorkspaceId = (state: RootState) => state.workspace.activeWorkspaceId;
export const selectActiveWorkspace = (state: RootState) =>
  state.workspace.activeWorkspace;

export const {
  setWorkspaces,
  setActiveWorkspaceFromId,
  setActiveWorkspaceFromWorkspace,
  updateWorkspace,
  setActiveWorkspaceFromToken,
} = workspaceSlice.actions;
export default workspaceSlice.reducer;
